<form>
  <payee-chip-dropdown
    [displayWith]="displayWith"
    [placeholder]="'CASES_TABLE.FILTERS.CASE_ID.LABEL' | translate"
    [selected]="selected"
    [(dropdownOpen)]="dropdownOpen"
    (removed)="clearFilter()"
  >
    <payee-form-field>
      <input
        payee-input
        [formControl]="caseIdControl"
        [placeholder]="'CASES_TABLE.FILTERS.CASE_ID.PLACEHOLDER' | translate"
        (paste)="onPaste($event)"
      />
      @if (caseIdControl.invalid && caseIdControl.dirty) {
        <span payee-error>
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
      }
    </payee-form-field>
    <button
      payee-button
      type="submit"
      class="top-margin-10"
      color="primary"
      (click)="applyFilter()"
    >
      {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
    </button>
  </payee-chip-dropdown>
</form>
